import { render, staticRenderFns } from "./RegionalPosition.vue?vue&type=template&id=2a03f5f2&scoped=true"
import script from "./RegionalPosition.vue?vue&type=script&lang=js"
export * from "./RegionalPosition.vue?vue&type=script&lang=js"
import style0 from "./RegionalPosition.vue?vue&type=style&index=0&id=2a03f5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a03f5f2",
  null
  
)

export default component.exports